var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":_vm.sm,"md":_vm.md,"offset-md":_vm.mdOffset}},[_c('div',{staticClass:"summary",domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9563a634","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/SectionSummary.vue
// module id = null
// module chunks = 